var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as jsCookie from 'js-cookie';
import fieldsToParams from './fields-to-params';
import sendTo from './send-to';
import { FieldName, HitType } from './types';
export var DEFAULT_TRACKER_NAME = 't0';
var Tracker = /** @class */ (function () {
    function Tracker(options) {
        var _a;
        this.fields = {};
        this.sendTo = sendTo;
        this.seq = 1;
        this.sessionIdKey = '_tsid';
        this.clientIdKey = '_tcid';
        var host = options.host, project = options.project, logstore = options.logstore, topic = options.topic;
        this.endpoint = "https://" + project + "." + host + "/logstores/" + logstore + "/track_ua.gif";
        this.fields = (_a = {},
            _a[FieldName.CLIENT_ID] = this.getClientId(),
            _a[FieldName.LANGUAGE] = this.getLanguage(),
            _a[FieldName.LOCATION] = this.getLocation(),
            _a[FieldName.PORTAL_TIME] = new Date().getTime(),
            _a[FieldName.SCREEN_RESOLUTION] = this.getScreenResolution(),
            _a[FieldName.SESSION_ID] = this.getSessionId(),
            _a[FieldName.TITLE] = document.title,
            _a[FieldName.TOPIC] = topic,
            _a[FieldName.VIEWPORT_SIZE] = this.getViewportSize(),
            _a);
    }
    Tracker.prototype.send = function (type, fields) {
        return __awaiter(this, void 0, void 0, function () {
            var reportFields, params, queryString, reportUrl;
            var _a;
            return __generator(this, function (_b) {
                reportFields = __assign(__assign(__assign({ type: type }, this.fields), fields), (_a = {}, _a[FieldName.SEQ] = this.seq, _a[FieldName.TIMESTAMP] = this.getUnixTimestamp(), _a));
                params = fieldsToParams(reportFields);
                queryString = Object.keys(params)
                    .filter(function (key) { return params[key] !== undefined; })
                    .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]); })
                    .join('&');
                reportUrl = this.endpoint + "?APIVersion=0.6.0&" + queryString;
                try {
                    this.seq += 1;
                    this.sendTo(reportUrl);
                    this.getClientId();
                    this.getSessionId();
                }
                catch (ex) {
                    if (window && window.console && typeof window.console.log === 'function') {
                        console.log('Failed to log to ali log service because of this exception:\n' + ex);
                        console.log('Failed log data:', reportUrl);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    Tracker.prototype.set = function (fields) {
        this.fields = __assign(__assign({}, this.fields), fields);
    };
    Tracker.prototype.pageview = function (rawPath, options) {
        var _a;
        var title = options.title, data = options.data;
        var path = rawPath.trim();
        if (path === '') {
            return;
        }
        var fieldsObject = (_a = {},
            _a[FieldName.PAGE] = path,
            _a);
        if (title) {
            fieldsObject[FieldName.TITLE] = title;
        }
        if (data) {
            fieldsObject[FieldName.DATA] = data;
        }
        this.send(HitType.pageview, fieldsObject);
    };
    Tracker.prototype.event = function (eventFileds, data) {
        var fieldsObject = __assign({}, eventFileds);
        if (data) {
            fieldsObject[FieldName.DATA] = data;
        }
        this.send(HitType.event, fieldsObject);
    };
    Tracker.prototype.getLocation = function () {
        var _a = window.location, protocol = _a.protocol, hostname = _a.hostname, pathname = _a.pathname, search = _a.search;
        return protocol + "//" + hostname + pathname + search;
    };
    Tracker.prototype.getLanguage = function () {
        return navigator.language.toLowerCase();
    };
    Tracker.prototype.getClientId = function () {
        var clientIdKey = this.clientIdKey;
        var clientId = jsCookie.get(clientIdKey);
        if (!clientId) {
            clientId = this.random() + "." + this.getUnixTimestamp();
        }
        var domain = this.getBaseDomain(window.location.hostname);
        jsCookie.set(clientIdKey, clientId, { expires: 365 * 2, domain: domain });
        return clientId;
    };
    Tracker.prototype.getSessionId = function () {
        var sessionIdKey = this.sessionIdKey;
        var sessionId = jsCookie.get(sessionIdKey);
        if (!sessionId) {
            sessionId = this.random() + "." + this.getUnixTimestamp();
        }
        var domain = this.getBaseDomain(window.location.hostname);
        jsCookie.set(sessionIdKey, sessionId, { expires: 1 / 48, domain: domain });
        return sessionId;
    };
    Tracker.prototype.getBaseDomain = function (hostName) {
        return hostName.split('.').slice(-2).join('.');
    };
    Tracker.prototype.getScreenResolution = function () {
        var screenWidth = window.screen.width;
        var screenHeight = window.screen.height;
        return screenWidth + "x" + screenHeight;
    };
    Tracker.prototype.getViewportSize = function () {
        var viewportWidth = window.innerWidth;
        var viewportHeight = window.innerHeight;
        return viewportWidth + "x" + viewportHeight;
    };
    Tracker.prototype.random = function () {
        return Math.round(2147483647 * Math.random());
    };
    Tracker.prototype.getUnixTimestamp = function () {
        return Math.round(new Date().getTime() / 1000);
    };
    return Tracker;
}());
export { Tracker };
//# sourceMappingURL=tracker.js.map


//////////////////
// WEBPACK FOOTER
// ../tracker/build/src/tracker.js
// module id = 1115
// module chunks = 0